// I18N — Footer copy translated via react-i18next.
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import Logo from "../../images/logo3.png";
import Services from '../../api/Services';

const ClickHandler = () => {
    window.scrollTo(10, 0);
};

const Footer = (props) => {
    const { t } = useTranslation();
    const year = new Date().getFullYear();
    return (
        <footer className="wpo-site-footer">
            <div className="wpo-top-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="widget">
                                <div className="logo">
                                    <Link className="navbar-brand" to="/">
                                        <img src={Logo} alt="Sokaab Logo" style={{width:"342px", height:"100px"}} />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="widget">
                                <div className="social">
                                    <ul>
                                    <li><a href='https://www.facebook.com/people/Sokaab/100079496871498/#' target='_blank' rel='noreferrer'> <i className="fi fa-brands fa-square-facebook"></i></a></li>
                                <li><a href='https://x.com/SOKAAB2' target='_blank' rel='noreferrer'><i className="fi fab fa-x-twitter"></i></a></li>
                                <li><a href='https://www.youtube.com/channel/UCaYsgDii78pi54BMpD5Sevg' target='_blank' rel='noreferrer'><i className="fi fa-brands fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="widget-title">
                                    <h3>{t('footer.aboutTitle')}</h3>
                                </div>
                                <p>{t('footer.aboutText')}</p>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>{t('footer.quickLinks')}</h3>
                                </div>
                                <ul>
                                    <li><Link to="/">{t('nav.home')}</Link></li>
                                    <li><Link to="about">{t('footer.whoWeAre')}</Link></li>
                                    <li><Link to="/contact">{t('nav.contact')}</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget s2">
                                <div className="widget-title">
                                    <h3>{t('footer.howItWorks')}</h3>
                                </div>
                                <ul>
                                    {Services.map((service, index) => (
                                        <li key={index}>
                                            <Link onClick={ClickHandler} to={`/how-it-works/${service.slug}`}>
                                                {service.title}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget newsletter-widget">
                                <div className="widget-title">
                                    <h3>{t('footer.contactUs')}</h3>
                                </div>
                                <p>{t('footer.contactText')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col col-lg-6 col-md-12 col-12">
                            <ul>
                                <li>{t('footer.copyright', { year })}</li>
                            </ul>
                        </div>
                        <div className="col col-lg-6 col-md-12 col-12">
                            <div className="link">
                                <ul>
                                    <li><Link to="/privacy">{t('nav.privacy')}</Link></li>
                                    <li><Link to="/terms">{t('nav.terms')}</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
